/** @format */

import ApiCollectionResponseInterface from '../api/ApiCollectionResponseInterface';
import PliCbd2Interface from '../platform/PliCbd2Interface';

export interface PliCbd2CollectionInterface extends ApiCollectionResponseInterface {
    'hydra:member': Array<PliCbd2Interface>;
}

export enum PlatformRmoType {
    MVNE = 1,
    PARTNER = 2,
}
